import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import GroupsCard from './GroupsCard';

import './Groups.css';

@inject('translationsStore', 'subscriptionsStore', 'filterStore')
@observer
export default class Groups extends Component {
  componentDidMount = () => {
    const { filterStore } = this.props;

    filterStore.addToMonitoring('groupFilter.combined');
    filterStore.addToMonitoring('groupFilter.free');
    filterStore.addToMonitoring('groupFilter.all');
  };

  selectCombined = () => {
    this.props.onSelect({ selected: 'combined' });
    this.props.onGroupChange("combined");
  };

  selectFree = () => {
    this.props.onSelect({ selected: 'free' });
    this.props.onGroupChange("free");
  };

  selectAllGroups = () => {
    this.props.onSelect({ selected: 'allgroups' });
    this.props.onGroupChange();
  };

  withAllFilterFn = () => {
    return this.props.subscriptionsStore.filtered;
  };

  withPlateFilterFn = () => {
    return this.props.subscriptionsStore.filtered.filter(subscription => subscription.vehicle !== null);
  };

  render() {
    const { translationsStore, subscriptions, subscriptionsStore } = this.props;

    const subscriptionsFree = subscriptions.filter(subscription => subscription.vehicle === null);
    return (
      <div className="Groups">
        <GroupsCard
          name="allgroups"
          items={this.withAllFilterFn().length}
          title={translationsStore.translate('subscriptionManager.groups.aggregatedAllSubscriptions')}
          description={subscriptionsStore.groupsLength('groupFilter', 'all')}
          selected={this.props.selected === 'allgroups'}
          onClick={this.selectAllGroups}
        />
		<GroupsCard
          name="combined"
          items={this.withPlateFilterFn().length}
          title={translationsStore.translate('subscriptionManager.groups.aggregatedCombinedSubscriptions')}
          description={subscriptionsStore.groupsLength('groupFilter', 'combined')}
          selected={this.props.selected === 'combined'}
          onClick={this.selectCombined}
          theme="alternative"
        />
        <GroupsCard
          name="free"
          items={subscriptionsFree.length}
          title={translationsStore.translate('subscriptionManager.groups.aggregatedFreeSubscriptions')}
          description={subscriptionsStore.groupsLength('groupFilter', 'free')}
          selected={this.props.selected === 'free'}
          onClick={this.selectFree}
          theme="alternative"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/SubscriptionManagerDashboard/SubscriptionsWithGroups/Groups/Groups.js